export enum StockStatus {
    AlwaysInStock = 'STOCK_STATUS_ALWAYS_IN_STOCK',
    ManageStock = 'STOCK_STATUS_TRACKED',
    SoldOut = 'STOCK_STATUS_SOLD_OUT',
}

const translationObject: { [Key in StockStatus]: string } = {
    [StockStatus.AlwaysInStock]: 'app.product.detail.stockOption.alwaysInStock',
    [StockStatus.ManageStock]: 'app.product.detail.stockOption.inStock',
    [StockStatus.SoldOut]: 'app.product.detail.stockOption.soldOut',
};

export const getStockStatusTranslationId = (stockStatus: StockStatus): string => {
    return translationObject[stockStatus];
};
